import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {Ofwca} from "../../../shared/interface/ofwca";
import {InsuranceCompany} from "../../../shared/interface/insurance-company";
import {ReplaySubject} from "rxjs";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {FormHelperService} from "../../../shared/services/form-helper.service";
import {AgentsProfileHiperioService} from "../../../shared/services/agents-profile-hiperio.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {delay, takeUntil} from "rxjs/operators";
import {HttpErrorResponse} from "@angular/common/http";
import { REGISTRATION_STATUS_REGISTERED } from 'src/app/shared/services/dict.service';
import {Dictionary} from "../../../shared/interface/dictionary";
import {HiperioConfigService} from "../../../shared/services/hiperio-config.service";
import {HiperioConfig} from "../../../shared/interface/hiperio-config";


export interface ConcludeChangeRegistrationDialogData {
  ofwca: Ofwca;
}

@Component({
  selector: 'app-conclude-change-registration-dialog',
  templateUrl: './conclude-change-registration-dialog.component.html',
  styleUrls: ['./conclude-change-registration-dialog.component.scss']
})
export class ConcludeChangeRegistrationDialogComponent implements OnInit, OnDestroy {

  changeRegistrationForm: FormGroup;
  partnerId: string;
  ofwca: Ofwca;
  insuranceCompany: InsuranceCompany;
  hiperioRegistrationConfigId: string;
  processingRequest = false;
  enableSaveButton = false;
  registrationControl: FormControl;
  hiperioConfigControl: FormControl;
  readonly REGISTRATION_STATUS_REGISTERED = REGISTRATION_STATUS_REGISTERED;


  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    public dialogRef: MatDialogRef<ConcludeChangeRegistrationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConcludeChangeRegistrationDialogData,
    private fb: FormBuilder,
    private formHelper: FormHelperService,
    private agentsProfileHiperioService: AgentsProfileHiperioService,
    private hiperioConfigService: HiperioConfigService,
    private snack: MatSnackBar,
  ) {
      this.ofwca = data.ofwca;
      this.partnerId = this.ofwca.partner.uuid;
      this.changeRegistrationForm = fb.group({
        registration: this.registrationControl = fb.control('',
          [Validators.required]),
        hiperioConfig: this.hiperioConfigControl = fb.control('',
          [Validators.required]),
      });
  }

  ngOnInit(): void {
    this.changeRegistrationForm.valueChanges
      .pipe(
        delay(0),
        takeUntil(this.destroyed$)
      )
      .subscribe(() => this.enableSaveButton = this.changeRegistrationForm.valid);

      this.hiperioConfigControl.valueChanges.pipe().subscribe( (value) => {
        if (value) {
          this.hiperioConfigService.get(value)
            .subscribe((agentsProfile: HiperioConfig) => {
              this.insuranceCompany = agentsProfile.insuranceCompany;
          });
        }
          this.registrationControl.reset();
        }
      );
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
  closeDialog(e): void {
    this.dialogRef.close(e);
  }

  sendForm(): void {
    this.processingRequest = true;

    this.agentsProfileHiperioService.sendConcludeRegistration(this.changeRegistrationForm.value, this.ofwca.uuid)
      .subscribe(() => {
        this.snack.open('Pomyślnie zawnioskowano o zmianę loginu', '', {
          duration: 2000,
        });
        this.processingRequest = false;
        this.dialogRef.close();
      }, (error: HttpErrorResponse) => {
        this.processingRequest = false;
        this.snack.open('Podczas aktualizacji salda wystąpił błąd', error.status.toString(), {
          duration: 2000,
        });


      })
    ;
  }

}
